function FirstPage() {

    return (
        <div className='card'>
            <div className='profile-picture'>
                <div loading="lazy" className='profile-banner'></div>
                <img loading="lazy" src={"/images/profile/icon.jpg"} width={200} alt="" />
            </div>
            <div className='personal-info'>
                <span>Gelff</span>
            </div>
            <label className='label'>﴾ Redes Sociais ﴿</label>
            <div className='my-links'>
                <a title='Discord' href='https://discord.gg/S3hqxTc6vH' target='_blank' rel='noreferrer'>
                    <button className='my-links-button'><img src='/images/discord.png' width={30} alt="" /></button>
                </a>
                <a title='Steam' href='https://steamcommunity.com/id/biohazardzx/' target='_blank' rel='noreferrer'>
                    <button className='my-links-button'><img src='/images/steam.png' width={30} alt="" /></button>
                </a>
                <a title='Spotify' href='https://open.spotify.com/user/317kvk6t3ctfstze22bbuw2ln7eq?si=85b8a7f8bccb4635' target='_blank' rel='noreferrer'>
                    <button className='my-links-button'><img src='/images/spotify.png' width={30} alt="" /></button>
                </a>
                <a title='Roblox' href='https://www.roblox.com/users/3354859054/profile' target='_blank' rel='noreferrer'>
                    <button className='my-links-button'><img src='/images/roblox.png' width={30} alt="" /></button>
                </a>
            </div>
            <label className='label'>﴾ Meus Projetos ﴿</label>
            <div className='projects'>
                {/* <div className='project'>
                    <img loading="lazy" src='/images/projects/mirai.jpg' width={110} alt="" />
                    <div>
                        <span>Mirai Community</span>
                        <span style={{ fontSize: 12 }}>• Discord • Social</span>
                        <span style={{ fontSize: 12 }}>• Roblox • Robux</span>
                        <a title='Mirai Community' href='https://discord.gg/BmchaFqYRM' target='_blank' rel='noreferrer'>
                            <button className='projects-button'>Entrar</button>
                        </a>
                    </div>
                </div> */}
                <div className='project'>
                    <img loading="lazy" src='/images/projects/mirai.webp' width={110} alt="" />
                    <div>
                        <span>Mirai UGC Store</span>
                        <span style={{ fontSize: 12 }}>• Roblox • UGC</span>
                        <span style={{ fontSize: 12 }}>• Games • Clothes</span>
                        <a title='Mirai UGC Store' href='https://www.roblox.com/communities/35080877/unnamed' target='_blank' rel='noreferrer'>
                            <button className='projects-button'>Entrar</button>
                        </a>
                    </div>
                </div>
                <div className='project'>
                    <img loading="lazy" src='/images/projects/minimania.png' width={110} alt="" />
                    <div>
                        <span>MiniMania</span>
                        <span style={{ fontSize: 12 }}>• Jogo • Economia</span>
                        <span style={{ fontSize: 12 }}>• Social • Coleção</span>
                        <a title='MiniMania' href='https://minimania.app' target='_blank' rel='noreferrer'>
                            <button className='projects-button'>Entrar</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FirstPage